import OptionValue from '../../../../Communication/OptionValue';
import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';

export default class ExportQueueSearchParams extends SearchParamsBase {
  initialize() {
    this.ExportId = '';
    this.SelectedOfficeIds = [];
    this.Status = [];
    this.Type = [];
    this.Notes = 'The Tipalti payment method is used exclusively in the US office.';
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'ExportId', label: 'ExportId', className: 'col-6', type: InputTypesEnum.Number },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-6',
      type: InputTypesEnum.MultiChoice,
      options: ExportQueueSearchParams.getStatusOptionsFunction(),
    },
    {
      fieldName: 'Type',
      label: 'Type',
      className: 'col-6',
      type: InputTypesEnum.MultiChoice,
      options: ExportQueueSearchParams.getTypesOptionsFunction(),
    },
    { fieldName: 'Notes', label: 'Notes', className: 'col-12', type: InputTypesEnum.Notes },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'ExportQueueSearchParams';
  static maxWidth = 1000;

  //---------------------------

  static getStatusOptionsFunction() {
    let options = [];
    options.push(new OptionValue('Pending', 1, false));
    options.push(new OptionValue('Running', 2, false));
    options.push(new OptionValue('Success', 3, false));
    options.push(new OptionValue('Error', 4, false));
    return options;
  }

  static getTypesOptionsFunction() {
    let options = [];
    options.push(new OptionValue('EOM', 1, false));
    options.push(new OptionValue('Ad Hoc', 2, false));
    return options;
  }
}
